import PropTypes from 'prop-types';
import React, { Component } from 'react';
import classNames from 'classnames/bind';
import TimerWrapper from '../TimerWrapper/TimerWrapper';
import * as styles from './CouponUrgencyMessage.css';

const cx = classNames.bind(styles);

class CouponUrgencyMessage extends Component {
    static propTypes = {
        expiryDate: PropTypes.instanceOf(Date),
        liveTextColor: PropTypes.string,
        timerTextColor: PropTypes.string,
        timerZone: PropTypes.string,
        customClass: PropTypes.string,
    };

    static defaultProps = {
        expiryDate: null,
        liveTextColor: '',
        timerTextColor: '',
        timerZone: '',
        customClass: '',
    };

    render() {
        const { expiryDate, timerTextColor, liveTextColor, timerZone, customClass } = this.props;
        return (
            <div className={cx('urgencyStatementWrapper', customClass)}>
                <TimerWrapper
                    finishTime={expiryDate}
                    wrapperClassName="coupon-livetextTheme"
                    timerTextColor={timerTextColor}
                    liveTextLabelColor={liveTextColor}
                    timerZone={timerZone}
                    removeTimerZeros
                    displaySingleDimentionTimer
                    liveTextLabelClassName="livetext-coupon"
                    liveTextLabel="Sale Ends in "
                    daysLeftMesg="days"
                    offerExpiredLable="Offer Expired"
                    removePrecedingZeros
                    addAdditionalMinute
                    timerTextConfig={{
                        h: 'hrs',
                        m: 'mins',
                        s: 'sec',
                    }}
                />
            </div>
        );
    }
}

export default CouponUrgencyMessage;
